import Button from '@ui/Button'
import Breadcrumb from '@common/Breadcrumb'
import {ROUTES,SITE } from '@/constants'
import TransformBanner from '@sections/TransformBanner'
import { useTreeAnimation } from '@helpers/useIntersectionObserver'
import { Link, Route } from 'react-router-dom'
 import { buildRows } from '../assets/js/common'
import MetaInfo from '@common/MetaInfo'
import { metaTitleFor } from '../assets/js/navBreadcrumb'
const { label, pageDesc, metaDesc } = metaTitleFor(ROUTES.AMC)

 const MANAGEMNT_TASK = [
  { title: 'Application Support',     desc: 'Resolve functional issues, technical problems, production incidents, and application-related challenges with structured support.' },
  { title: 'Enhancements & Change Requests',      desc: 'Add new features, modify existing workflows, integrate new systems, and adapt applications to changing business requirements.' },
  { title: 'Security & Technology Updates',           desc: 'Keep applications, frameworks, libraries, dependencies, and configurations updated to reduce technology and security risks.' },
  { title: 'Performance Optimization',  desc: 'Identify and address performance bottlenecks across application code, databases, APIs, and infrastructure.' },
  { title: 'Preventive Maintenance',                      desc: 'Proactively identify potential issues before they become production problems through regular reviews, monitoring, and maintenance activities.' },
  { title: 'AMC-Based Support',   desc: 'Flexible Annual Maintenance Contract (AMC) engagements for organizations that require dependable, ongoing application support, even for long tenures.' },  
]
const AMC_KEY = [
  { title: 'Proactive Support' },
  { title: 'Continuous Improvement' },
  { title: 'Security-Minded' },
  { title: 'Operations' },
  { title: 'Scalable Technology' },
  { title: 'Flexible Engagement Models' },
]
const AMC_SERVICE_IDS = ['egov-branch-1', 'egov-branch-2', 'egov-branch-3']

const AMC_SERVICE = [
  {  title: 'DevOps & Infrastructure Management',        desc: 'Manage servers, environments, deployments, monitoring, backups, configurations, and operational infrastructure for dependable application delivery.',link: ROUTES.DEVOPS },
  {  title: 'Cloud Services & Management',     desc: 'Migrate, manage, modernize, secure, and optimize cloud environments based on your applications and business requirements.', link: ROUTES.CLOUD_SERVICES},
  {  title: 'Domain, Email & Hosting Services',  desc: 'Manage domains, DNS, business email, hosting, SSL, backups, migrations, and the essential services behind your digital presence.',link: ROUTES.DOMAIN_DNS_EMAIL_SERVER_MANAGEMENT  },
]

const AMC_MAINTENANCE  = [
   { name: 'Application Monitoring',    color: { bg: '#f7d3cf', text: '#7a3228' } },
 
  { name: 'Bug Fixes',     color: { bg: '#9bcf60', text: '#2e5a0e' } },
  { name: 'Technical Support',       color: { bg: '#7fc2eb', text: '#1a4f72' } },
 
  { name: 'Enhancements',     color: { bg: '#a9e5e5', text: '#1a5c5c' } },
  { name: 'Security Updates',   color: { bg: '#dbd1fc', text: '#4a2d8a' } },
  { name: 'Performance Optimization',           color: { bg: '#9bcf60', text: '#2e5a0e' } },
  { name: 'Database Support',      color: { bg: '#dbd1fc', text: '#4a2d8a' }  },
  { name: 'API & Integration Support',       color: { bg: '#f7d3cf', text: '#7a3228' } },
  { name: 'Version Upgrades',         color: { bg: '#7fc2eb', text: '#1a4f72' }  },
]
  const AMC_MAINTENANCERows = buildRows(AMC_MAINTENANCE)

  
export default function SoftwareMaintenanceSupportAMC() {
  useTreeAnimation('egov-travel-dot', AMC_SERVICE_IDS, 600)

  return (
    <>
    {/* <MetaInfo
        title="Software Maintenance & Support (AMC) | CruxBytes"
        description="Keep your applications secure, reliable and up to date with software maintenance, technical support, enhancements and AMC services from CruxBytes."
        keywords="software maintenance, application support, AMC services, annual maintenance contract, technical support, security updates, CruxBytes"
      /> */}
       <MetaInfo
      title={label}
      description={metaDesc}
      keywords=""
      />
      <main id="main-content" className="page-wrapper">
         <div className="page-hero">
           <div className="bg-grid bg-grid--fill" aria-hidden="true" />
           <div className="container">
             {/* <div className="section-label">- Maintenance & Support -</div> */}
             <Breadcrumb />
             <h1 data-aos="fade-up" data-aos-delay={100}>
              {/* Software Maintenance & Support */}
              {label}
              </h1>
             <p className="page-subtitle" data-aos="fade-up" data-aos-delay={200}>
             {/* Keep applications secure, optimized, and running at peak performance. */}
             {pageDesc}
             </p>
             
             <div className="inner-page-actions">
               <Button  href={ROUTES.SALES_ENQUIRY}  variant="primary" icon="fa-arrow-right" iconPos="right" data-aos="fade-up" data-aos-delay={300}>
                 Get a Free Quote
               </Button>
              
             </div>
           </div>
         </div>
         {/* section 1 */}
        <section className="bg-linear-gradient-light section-py text-center" >
      <div className="container">
         <p data-aos="fade-up" >
             Software doesn't stop evolving after deployment. New business requirements, technology changes, security threats, integrations, and user expectations continuously create the need for updates and improvements.
            </p>
            <p data-aos="fade-up" >
             CruxBytes provides ongoing software maintenance and support to keep applications stable, secure, optimized, and aligned with changing business needs. Our maintenance services combine <span className='text-bold'>technical support, application monitoring, issue resolution, security updates, performance optimization, and continuous enhancements</span> to extend the life and value of your software.
            </p>
        
            <ul className="deliverables-grid--centered flip-grid">
          {MANAGEMNT_TASK.map((item, i) => (
            <li
              key={item.title}
              className="flip-card"
              tabIndex={0}
              data-aos="fade-up"
              data-aos-delay={(i % 3) * 70}
            >
              <div className="flip-card__inner">
                <div className="flip-card__face">
                  {/* <span  aria-hidden="true">
                    <i className={`fa-solid ${item.icon}`} />
                  </span> */}
                  <div className="flip-card__title">{item.title}</div>
                </div>
                <div className="flip-card__face flip-card__face--back">
                  {/* <span  aria-hidden="true">
                    <i className={`fa-solid ${item.icon}`} />
                  </span> */}
                  <p className="flip-card__desc">{item.desc}</p>
                </div>
              </div>
            </li>
          ))}
        </ul>
      
       
      </div>
    </section>

     {/* section 2 */}
        <section className="section-py text-center">
      <div className="container">
  <div  data-aos="fade-up">
          <h2>
           What We Strive For
          </h2>
        </div>  
        <p className="pt-4" data-aos="fade-up">
             Our focus is not simply keeping systems running. We look at the technology environment as a whole to identify potential issues, improve operational efficiency, strengthen security, and prepare infrastructure for future requirements.
        </p>
    <div className="m-4">
         <ul className="icon-list pt-2" role="list" data-aos="fade-up">
  {AMC_KEY.map(({ title }) => (
    <li key={title} className="icon-list-item">
      <span className="icon-badge" aria-hidden="true">
        <i className="fa-solid fa-check" />
      </span>
      <span className="icon-list-title">{title}</span>
    </li>
  ))}
</ul>
        </div>
        
      </div>
      </section>

{/* section 3 */}
      <section className="section-py bg-peach"  aria-label="Investing in our people" data-aos="fade-up">
        <div className="container">
           
        <div className="text-center" data-aos="fade-up">
          <h2>
           Our Maintenance Coverage
          </h2>
        </div>  
            <div className="domain-grid pb-4" aria-label="List of industries we serve">
                {AMC_MAINTENANCERows.map((row, rowIdx) => (
                  <div key={rowIdx} className="domain-row">
                    {row.map((domain, chipIdx) => (
                      <span
                        key={domain.name}
                        className="domain-chip"
                        style={{ '--chip-bg': domain.color.bg, '--chip-text': domain.color.text }}
                        data-aos="fade-up"
                        data-aos-delay={chipIdx * 30}
                      >
                        {domain.name}
                      </span>
                    ))}
                  </div>
                ))}
              </div>
<div className="text-center pt-4" data-aos="fade-up">
          <h5>
           Keep Your Application Moving Forward
          </h5>
        </div> 

            <div className="sc-row" data-aos="fade-up">
             <div className="sc-col-text">
            <p >
             Whether you need ongoing AMC support or an extended technical team for an existing application, CruxBytes helps keep your software dependable today while preparing it for tomorrow's requirements.
            </p></div> <div className="sc-col-text">
            <p>
              We have various engagement models and packages for small sized startups as well as for established corporates and PSUs.
            </p>
          </div>
        </div>
            <div className='text-center pt-4'>
<Button  href={ROUTES.SALES_ENQUIRY}  variant="primary" icon="fa-arrow-right" iconPos="right" data-aos="fade-left">Reach out to us and know more.</Button>
</div>
          </div>
        </section>
    {/* section4 */}
       <div className="policy-tree-section">
      <div className="text-center">
        <span className="policy-root">Service Beyond AMC</span>
      </div>

      <div className="policy-tree-connector">
        <svg viewBox="0 0 1200 140" preserveAspectRatio="xMidYMid meet" aria-hidden="true">
          <path
            id="egov-branch-1"
            className="branch-line"
            d="M 600,0 L 600,45 Q 600,70 550,70 L 212,70 Q 192,70 192,95 L 192,140"
          />
          <path
            id="egov-branch-2"
            className="branch-line"
            d="M 600,0 L 600,140"
          />
          <path
            id="egov-branch-3"
            className="branch-line"
            d="M 600,0 L 600,45 Q 600,70 650,70 L 988,70 Q 1008,70 1008,95 L 1008,140"
          />
          <circle className="travel-dot" id="egov-travel-dot" cx="600" cy="0" r="5" />
        </svg>
      </div>

      <ul className="policy-cards-row policy-cards-row--four policy-cards-row--three" role="list" data-aos="fade-up">
       {AMC_SERVICE.map(({ icon, title, desc, link }) => (
  <li className="policy-card policy-card--link bg-linear-gradient-light" key={title}>    
    <h6>{title}</h6>
    <span className="policy-card--desc">{desc}</span>
    <Link to={link} className="wcs-arrow" aria-label={`Learn more about ${title}`}>
      <i className="fa-solid fa-arrow-right" aria-hidden="true" />
    </Link>
  </li>
))}
      </ul>
    </div>
         <TransformBanner />
         </main>
         </>
  )
}